import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';
import ExamAttemptView from './routes/ExamAttemptView';

const ViewExamSubmissionLazy = React.lazy(
	() => import(/* webpackChunkName : 'ViewExamSubmission' */ './components')
);

export default () => {
	return [
		{
			path: 'examgrading-setup/exam-setup/:campusId/:examId/view-submission/:configId',
			element: (
				<AsyncLoading
					component={
						<ViewExamSubmissionLazy
							permission="CanViewExamGradingSetup"
							featureFlag="FeatureFlag:OnlineExams"
						/>
					}
				/>
			),
		},
		ExamAttemptView(),
	];
};
